var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"embed-header"},[_c('div',{staticClass:"brand"},[_c('img',{staticClass:"partner-logo",attrs:{"src":_vm.logoSrc,"alt":"Logo Parceiro"}}),_c('span',{staticClass:"course-name"},[_vm._v(_vm._s(_vm.courseName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }